<template>
  <div class="initiate_discussion_wrap">
    <div class="initiate_discussion_main">
      <div class="subordinate_module" v-if="region=='all'&&editDetailsInfo==null">
        <p class="tag_item_lable"><i>*</i><span>所属讨论区模块</span></p>
        <el-select v-model="regionValue" @change="checkRegion" placeholder="请选择讨论所属模块">
          <el-option
            v-for="item in regionOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <p class="isSubordinateModule" v-if="isSubordinateModule">请选择讨论所属模块</p>
      </div>
      <div class="theme_module">
        <p class="tag_item_lable"><i>*</i><span>主题</span></p>
        <el-input
          type="textarea"
          placeholder="请输入内容"
          maxlength="300"
          show-word-limit
          v-model.trim="themeValue"
          @focus="isThemeFocus"
          @blur="isThemeBlur">
        </el-input>
        <p class="is_theme_value" v-if="isThemeValue">请输入主题内容</p>
      </div>
      <div class="content_module">
        <p class="tag_item_lable"><i></i><span>内容</span></p>
        <v-editor v-model="discussContent" class="discuss_content"></v-editor>
      </div>
      <div class="subordinate_teach" v-if="isChapterList">
        <p class="tag_item_lable"><i></i><span>所属教学内容</span></p>
        <el-cascader
         expand-trigger="hover"
         :options="chapterOption"
         :props="chapterOptionProps"
         v-model="selectedChapter"
         clearable
         change-on-select
         placeholder="全部教学章节">
        </el-cascader>
      </div>
      <div class="Anonymous_publication" v-if="!userType">
        <el-checkbox v-model="isAnonymousValue">匿名发表</el-checkbox>
      </div>
      <div class="is_top_ck" v-if="userType">
        <el-checkbox v-model="isTopValue" :disabled="isTopDisabled">置顶</el-checkbox>
        <p v-if="isTopNum>=3&&!isTopValue&&isTopDisabled">（最多置顶3条讨论主题哦！）</p>
      </div>
    </div>
    <div class="publish">
      <el-button @click="publishDiscuss">发表</el-button>
    </div>
  </div>
</template>
<script>
import vEditor from "@/components/wjlEditor/index.vue";
import * as api from "../../../../../../api/discussApi";
export default {
  components:{
    vEditor,
  },
  props: {
    region: {
      type: String,
      default: ''
    },
    editDetailsInfo: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      regionOptions: [
        { value: 2, label: '老师答疑区' },
        { value: 3, label: '课堂交流区' }
      ],
      regionValue: '', // 所属区域
      themeValue: '', // 主题
      discussContent: '', // 内容
      chapterOption: [],
      chapterOptionProps: {
        value: 'id',
        label: 'catalogName',
      },
      selectedChapter:[], // 所属章节
      isAnonymousValue: false,
      isTopValue: false,
      isTopDisabled: false,
      userType: (sessionStorage.getItem('userType')==0||sessionStorage.getItem('userType')==1)?true:false,
      isSubordinateModule: false,
      isThemeValue: false,
      isChapterList: true,
      isTopNum: 0,
      maxWords: 1000
    }
  },
  created() {
    if(this.region=='teacher'){
      this.isChapterList = true
    }else{
      this.isChapterList = false
    }
    if(this.region=='teacher'){this.regionValue=2}
    if(this.region=='student'){this.regionValue=3}
  },
  mounted() {
    this.getChapter()
  },
  methods: {
    getChapter(){
      let that = this;
      api.getChapter(that.$route.query.id).then(rs=>{
        if(rs.code==0){
          that.chapterOption = that.getTreeData(rs.data)
        }
      }).then(()=>{
        if(that.editDetailsInfo){
          that.regionValue = that.editDetailsInfo.discussionAreaId
          that.themeValue = that.editDetailsInfo.theme
          that.discussContent = that.editDetailsInfo.content
          that.isAnonymousValue = that.editDetailsInfo.anonymous!=null?(that.editDetailsInfo.anonymous==0?true:false):false
          that.isTopValue = that.editDetailsInfo.roofPlacement
          that.selectedChapter = that.editDetailsInfo.catalogIds.split(',').map(Number)
        }else{
          that.regionValue = ''
          that.themeValue = ''
          that.discussContent = ''
          that.isAnonymousValue = false
          that.isTopValue = false
          that.selectedChapter = []
          if(this.region=='teacher'){this.regionValue=2}
          if(this.region=='student'){this.regionValue=3}
        }
        this.getTopNum()
      }).catch(err=>{
        console.log(err)
      })
    },
    getTopNum(){
    	let obj = {
    		classId: this.$route.query.classId,
        courseId: this.$route.query.id
    	}
    	api.getTopNum(obj).then(rs=>{
        if(rs.code==0){
          this.isTopNum = rs.data
        }
      }).then(()=>{
        if(this.isTopNum>=3){
          if(this.isTopValue){
            this.isTopDisabled = false
          }else{
            this.isTopDisabled = true
          }
        }else{
          this.isTopDisabled = false
        }
      }).catch(err=>{
        onsole.log(err)
      })
    },
    getTreeData(data){
      for(var i=0;i<data.length;i++){
        if(data[i].children.length<1){
          data[i].children=undefined;
        }else {
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    checkRegion(){
      if(this.regionValue==''){
        this.isSubordinateModule=true
      }else{
        this.isSubordinateModule=false
        if(this.regionValue==2){ this.isChapterList = true }
        if(this.regionValue==3){ this.isChapterList = false }
      }
    },
    isThemeFocus(){
      this.isThemeValue = false
    },
    isThemeBlur(){
      if(this.themeValue==''){
        this.isThemeValue = true
      }else{
        this.isThemeValue = false
      }
    },
    publishDiscuss(){
      if(this.regionValue==''){
        this.isSubordinateModule = true
      }else{
        this.isSubordinateModule = false
      }
      if(this.themeValue==''){
        this.isThemeValue = true
      }else{
        this.isThemeValue = false
      }
      if(this.regionValue==''||this.themeValue==''){ return }
      let chapter = ''
      let catalogIds = this.selectedChapter.join()
      if(this.selectedChapter.length>0){
        chapter = this.selectedChapter.pop()
      }else{
        chapter = null
      }
      let obj = {}
      let request = null
      if(this.editDetailsInfo==null){
        obj = {
          discussionAreaId: this.regionValue,
          theme: this.themeValue,
          content: this.discussContent,
          courseId: this.$route.query.id,
          catalogId: chapter,
          classId: this.$route.query.classId,
          resourceId: null,
          resourceType: null,
          anonymous: this.isAnonymousValue?0:1, //0匿名、1公开
          roofPlacement: this.isTopValue?1:0, //0不置顶、1置顶
          catalogIds: catalogIds
        }
        request = api.publishDiscuss(obj);
      }else{
        obj = {
          id: this.editDetailsInfo.id,
          discussionAreaId: this.regionValue,
          theme: this.themeValue,
          content: this.discussContent,
          courseId: this.$route.query.id,
          catalogId: chapter,
          classId: this.$route.query.classId,
          resourceId: null,
          resourceType: null,
          anonymous: this.isAnonymousValue?0:1, //0匿名、1公开
          roofPlacement: this.isTopValue?1:0, //0不置顶、1置顶
          catalogIds: catalogIds
        }
        request = api.publishDiscussUpdate(obj)
      }
      request.then(rs=>{
        if(rs.code==0){
          this.$messageSuccess('发表成功')
          this.$emit('publish')
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  },
}
</script>
<style lang="scss">
  .initiate_discussion_wrap{
    height: calc(100% - 50px);
    .initiate_discussion_main{
      height: calc(100% - 67px);
      overflow-x: hidden;
      overflow-y: auto;
      padding: 0 24px;
      box-sizing: border-box;
    }
    .subordinate_module,.theme_module,.content_module,.subordinate_teach{
      .tag_item_lable{
        margin: 16px 0 12px;
        i{
          color:#F43D3D;
        }
        span{
          font-size:14px;
          font-weight:400;
          color:rgba(51,51,51,1);
        }
      }
    }
    .subordinate_module{
      .el-select{
        width:240px;
        height:34px;
        border:1px solid rgba(226,226,226,1);
        border-radius:4px;
        .el-input{
          width:240px;
          height:34px;
          input{
            height:34px;
            line-height: 34px;
          }
          .el-input__icon{
            line-height: 34px;
          }
        }
      }
      .isSubordinateModule{
        color: #F43D3D;
        margin-top: 4px;
        font-size: 14px;
      }
    }
    .theme_module{
      .el-textarea{
        width: 100%;
        height:64px;
        background: #fff;
        border:1px solid rgba(230,230,230,1);
        border-radius:4px;
        .el-textarea__inner{
          width: 100%;
          height: 100%;
          border: none;
          resize: none;
          background: #fff;
        }
        .el-textarea__inner:focus{
          background: #fff;
        }
      }
      .is_theme_value{
        color: #F43D3D;
        margin-top: 4px;
        font-size: 14px;
      }
    }
    .content_module{
      .discuss_content{
        word-break: break-all;
        .ql-editor{
          min-height: 200px;
        }
      }
    }
    .subordinate_teach{
      .el-select{
        width:240px;
        height:34px;
        border:1px solid rgba(226,226,226,1);
        border-radius:4px;
        .el-input{
          width:240px;
          height:34px;
          input{
            height:34px;
            line-height: 34px;
          }
          .el-input__icon{
            line-height: 34px;
          }
        }
      }
    }
    .Anonymous_publication{
      margin: 16px 0;
    }
    .is_top_ck{
      margin: 16px 0;
      display: flex;
      align-items: center;
      p{
        color:#F43D3D;
      }
    }
    .publish{
      border-top:1px solid rgba(230,230,230,1);
      text-align: center;
      margin: 0 24px;
      button{
        padding: 0;
        width:96px;
        height:34px;
        background:rgba(83,151,247,1);
        border-radius:4px;
        color: #fff;
        margin-top: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/discuss/component/initiateDiscussion.vue